<div class="category-popup-container">
    <div class="close-btn-container">
        <div class="close-btn" (click)="close_dialogue('close')" (keydown.enter)="close_dialogue('close')"
            (keydown.space)="close_dialogue('close')">
        </div>
    </div>

    <div class="header-container">
        <div class="category-header">
            {{'filter_dropdowns.sel_cluster' | translate}}
        </div>
    </div>

    <div class="dropdown-container">
        <mat-form-field class="cluster-dropdown" appearance="outline">
            <mat-label>{{'filter_dropdowns.sel_cluster' | translate}}</mat-label>
            <md-input-container>
                <input matInput class="cluster-input" [matAutocomplete]="clusterAutoComplete"
                    [(ngModel)]="filteredData.cluster.searchText" (ngModelChange)="autoComplete($event, 'cluster')"
                    type="text" title="{{filteredData?.cluster?.searchText?.name}}">
            </md-input-container>

            <mat-autocomplete #clusterAutoComplete="matAutocomplete" [displayWith]="clusterValueMapper">
                <mat-option class="cluster-options" [value]="item" *ngFor="let item of uniqueClusterList"
                    title="{{item?.name}}">
                    {{item?.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="category-dropdown" appearance="outline">
            <mat-label>{{'filter_dropdowns.sel_category' | translate}}</mat-label>
            <md-input-container>
                <input matInput class="category-input" [matAutocomplete]="categoryAutoComplete"
                    [(ngModel)]="filteredData.category.searchText" (ngModelChange)="autoComplete($event, 'category')"
                    type="text" title="{{filteredData?.category?.searchText?.name}}" [disabled]="categoryDisabled">
            </md-input-container>

            <mat-autocomplete #categoryAutoComplete="matAutocomplete" [displayWith]="categoryValueMapper">
                <mat-option class="category-options" [value]="item" *ngFor="let item of filteredData.category.list"
                    title="{{item?.name}}">
                    {{item?.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <div class="button-container">
        <button mat-flat-button class="select-btn" [ngClass]="{'disabled-btn': disableSubmit}"
            (click)="close_dialogue('select')" [disabled]="disableSubmit">
            {{'search.select' | translate}}
        </button>
    </div>
</div>